import { React, useContext, useState, } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
// import { TableHeaderContext } from "../../Contexts/TableHeaderContext";
import IndustryFilter from "../../Components/RefineSearchComponents/IndustryFilter";
import SectorFilter from "../../Components/RefineSearchComponents/PESectorFilter";
import StageFilter from "../../Components/RefineSearchComponents/StageFilter";
import RoundFilter from "../../Components/RefineSearchComponents/RoundFilter";
import InvestorTypeFilter from "../../Components/RefineSearchComponents/InvestorTypeFilter";
import DealRangeFilter from "../../Components/RefineSearchComponents/DealRangeFilter";
import FirmTypeFilter from "../RefineSearchComponents/FirmTypeFilter";
// import CityFilter from "../../Components/RefineSearchComponents/CityFilter";
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import Tags from "../RefineSearchComponents/Tags";
import InvestorCityTag from '../RefineSearchComponents/InvestorCityTag';
import InvestorDealFilter from '../RefineSearchComponents/InvestorDealFilter'
import { UserContext } from "../../Contexts/UserContext";
import { useEffect } from "react";
import axios from "axios";
import { filterSectorByIndutry, refineSearchSubFirmTypeUrl, tagList } from "../../Config/config";
import { useLocation, useNavigate } from "react-router-dom";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import { Tooltip } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import DefinitionModal from "../TagDefinitionModal";
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import FirmTypeSubMenu from "../RefineSearchComponents/FirmTypeSubMenu";

/**
 * The `AdvisorInvestmentRefineSearch` function is a React component that renders a form for refining
 * search filters for investment advisors.
 * @returns a JSX element.
 */
export default function AdvisorInvestmentRefineSearch({ customPathname, generalPathname }) {
    const { setrefineSearchFilters, setSectors,dropdown, onErrorHandler ,dbDropdown , setDbDropdown ,setMonthPickerValue ,refineSearchFilters ,setSwitchState, InvestorOptions , setInvestorOptions, SwitchState ,TargetCompanyOptions , setTargetCompanyOptions , lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions, setSubFirmType, getSectorByIndustry, accessControl } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(0);
    const { getToken } = useContext(UserContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = useLocation()
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);


    //local updated options
    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])
    const [StageOptions, setStageOptions] = useState([])
    const [RoundOptions, setRoundOptions] = useState([])
    const [InvestorTypeOptions, setInvestorTypeOptions] = useState([])
    const [FirmTypeOptions, setFirmTypeOptions] = useState([])
    const [FirmSubTypeOptions, setFirmSubTypeOptions] = useState([])
    const [DealRange, setDealRange] = useState({ from: "", to: "" })
    const [invDealRange, setInvDealRange] = useState({ from: "", to: "" })
    const [TagSwitchState, setTagSwitchState] = useState(true)
    const [TagsOptions, setTagsOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [MinDealOptions, setMinDealOptions] = useState([])
    const [MaxDealOptions, setMaxDealOptions] = useState([])

  /**
   * The `applyFilter` function updates the refine search filters based on the selected options.
   */
    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedSectors = SectorOptions.filter(option => option.isChecked);
        const selectedStages = StageOptions.filter(option => option.isChecked);
        const selectedRounds = RoundOptions.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedInvestorType = InvestorTypeOptions?.filter(option => option.isChecked);
        const selectedFirm = FirmTypeOptions?.filter(option => option.isChecked);
        const selectedFirmSubTypes = FirmSubTypeOptions?.filter(option => option.isChecked);
        const invMin = MinDealOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const invMax = MaxDealOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedOperators = SwitchState;
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedInvestor = InvestorOptions?.filter(option => option.isChecked); 
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const firmTypeNames = selectedFirm?.filter(firm => firm.isChecked).map(firm => firm.name) ?? [];
        let filteredFirmSubTypes = null;

        const excludedNames = ['Healthcare(PE)', 'Cleantech(PE)', 'Healthcare(VC)', 'Cleantech(VC)'];

        if (firmTypeNames.includes('PE') || firmTypeNames.includes('VC')) {
            filteredFirmSubTypes = selectedFirmSubTypes?.filter(sub => {
                const isPE = sub.name?.includes('(PE)') || sub.originalName?.includes('(PE)');
                const isVC = sub.name?.includes('(VC)') || sub.originalName?.includes('(VC)');

                if (firmTypeNames.includes('PE') && firmTypeNames.includes('VC')) {
                    return isPE || isVC;
                } else if (firmTypeNames.includes('PE')) {
                    return isPE;
                } else if (firmTypeNames.includes('VC')) {
                    return isVC;
                }
                return false;
            })?.map(sub => {
                if (!excludedNames.includes(sub.name)) {
                    return {
                        ...sub,
                        name: sub.name.replace(/\((PE|VC)\)/, ''),
                    };
                }
                return sub;
            }) ?? null;

            if (filteredFirmSubTypes.length === 0) {
                filteredFirmSubTypes = null;
            }
        }

        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                industry: selectedIndustries,
                sector: selectedSectors,
                city: selectedCity,
                investorType: selectedInvestorType,
                firmType: selectedFirm,
                firm_Sub_type: filteredFirmSubTypes, 
                operator: TagSwitchState ? 1 : 0,
                tags: TagsOptions,
                dealRange: DealRange?.from != "" && DealRange?.to != "" ? [{ id: 0, name: DealRange?.from }, { id: 1, name: DealRange?.to }] : [],
                dealInvestorRange: invDealRange?.from != "" && invDealRange?.to != "" ? [{ id: 0, name: invDealRange?.from }, { id: 1, name: invDealRange?.to }] : [],
                deals_operator : selectedOperators,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                investor_id : selectedInvestor ,
                target_company:selectedTargetCompany,
            },
            [customPathname]: {
                ...prev[customPathname],
                round: selectedRounds,
                stage: selectedStages,
            },
        }))
    }

   /**
    * The function `resetFilter` resets a specific filter in the `refineSearchFilters` state object by
    * setting its value to an empty object.
    */
    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {}
        }))
        setTargetCompanyOptions([]);
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setSectors([]);
        setInvestorOptions([]);
    }



    // Submitting Refine Search Form 
  /**
   * The function `refineSearchFilter` updates the search filters, resets the month picker value,
   * applies the filters, deselects any selected items, and navigates to a custom pathname if the
   * current pathname is different.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. It contains information about the event, such as the type of event, the target element,
   * and any additional data associated with the event. In this case, it is used to prevent the default
   * behavior of the event, which is
   */
    const refineSearchFilter = (event) => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        event.preventDefault();
        setCurrentPage(1);
        applyFilter();
        setSelected(false)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }

    }

  /**
   * The `onResetClick` function resets the current page, filters, and navigates to a custom pathname
   * if it is different from the current location.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. In this case, it is the click event that occurred when the user clicked on a reset
   * button or link.
   */
    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

 /**
  * The function `accordionClick` sets the selected value to either 0 or the provided value.
  * @param val - The `val` parameter is the value that is passed to the `accordionClick` function. It
  * is used to determine which accordion item should be selected.
  */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    useEffect(() => {
        const ids = IndustriesOptions?.length > 0 ? 
            IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id) : [];

        if (ids?.length > 0) {
            getSectorByIndustry(ids, "investments")
        } else {
            setSectors([])
        }

    }, [IndustriesOptions])

    useEffect(() => {
        if(accessControl?.peindustries?.id?.length > 0){
            const ids = accessControl ? accessControl?.peindustries?.id : []
            getSectorByIndustry(ids, "investments")
        }
    }, [])

    // useEffect(() => {
    //     const ids = FirmTypeOptions?.filter(industry => industry.isChecked)?.map(option => option.id);

    //     if (ids?.length > 0) {
    //         let firmType = "All";
    //         if (ids.length === 1) {
    //             if (ids[0] === 1) firmType = "PE";
    //             else if (ids[0] === 2) firmType = "VC";
    //             // Add more mappings here if needed
    //         }

    //         axios.post(refineSearchSubFirmTypeUrl, {
    //             firm_type: firmType,
    //         }, {
    //             headers: {
    //                 "Authorization": getToken()
    //             }
    //         }).then(response => {
    //             if (response.status === 200) {
    //                 setSubFirmType(response.data?.firmType ?? []);
    //             } else {
    //                 setSubFirmType([]);
    //             }
    //         }).catch(onErrorHandler);
    //     } else {
    //         setSubFirmType([]);
    //     }
    // }, [FirmTypeOptions]);

    const getSearchTags = async (searchText, type) => {
        try {
        const response = await axios.post(tagList, {
            "tag": searchText,
            "includes_secondary_tags": secondaryTagCheck,
            "type"    : type

        }, {
            headers: {
            "Authorization": getToken()
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
        } catch (error) {
            return [];
        }
    }


    const fetchData = async () => {
        const tags = await getSearchTags("ALL", "noncompetitor");
        const competitorTags = await getSearchTags("ALL", "competitor")
        const secondaryTags = await getSearchTags("ALL", "secondary")
        console.log(tags, competitorTags, 'promi')
        openTagModal(tags, competitorTags, secondaryTags)
    };
    
    const [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({})
    const [secondaryTagCheck, setSecondaryTagCheck] = useState(true);
    console.log(defValues, 'showValues');

    const openTagModal = (non_comp, comp, s_tags) => {
        setShowDefinitionModal(true);
        setDefValues({
            non_comp: non_comp,
            comp: comp,
            s_tags: s_tags
        })
    }

    const defCloseHandler = () =>{
        setShowDefinitionModal(false);
        setDefValues({})
    }

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    const getPeVcSelectedTypes = () => {
        return FirmTypeOptions?.filter(option => 
        (option.id === 1 || option.id === 2) && option.isChecked
        ) || [];
    };

    // Helper functions to count applied filters for each section
    const getCompanyFiltersCount = () => {
        let count = 0;
        if (IndustriesOptions?.length > 0 && IndustriesOptions.some(option => option.isChecked)) count++;
        if (SectorOptions?.length > 0 && SectorOptions.some(option => option.isChecked)) count++;
        if (CityOptions?.length > 0 && CityOptions.some(option => option.isChecked)) count++;
        return count;
    };

    const getDealFiltersCount = () => {
        let count = 0;
        if (StageOptions?.length > 0 && StageOptions.some(option => option.isChecked)) count++;
        if (RoundOptions?.length > 0 && RoundOptions.some(option => option.isChecked)) count++;
        if (InvestorTypeOptions?.length > 0 && InvestorTypeOptions.some(option => option.isChecked)) count++;
        if (FirmTypeOptions?.length > 0 && FirmTypeOptions.some(option => option.isChecked)) count++;
        if (DealRange?.from !== "" || DealRange?.to !== "") count++;
        if (invDealRange?.from !== "" || invDealRange?.to !== "") count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (InvestorOptions?.length > 0 && InvestorOptions.some(option => option.isChecked)) count++;
        if (TargetCompanyOptions?.length > 0 && TargetCompanyOptions.some(option => option.isChecked)) count++;
        if (lAdvisorsOptions?.length > 0 && lAdvisorsOptions.some(option => option.isChecked)) count++;
        if (tAdvisorsOptions?.length > 0 && tAdvisorsOptions.some(option => option.isChecked)) count++;
        if (TagsOptions?.length > 0) count++;
        return count;
    };

    return (
        <div className="bg-white h-full w-full">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full flex flex-col">
                    <main className="flex-1 w-full py-2 md:py-4 overflow-visible">
                        <div className="h-full flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4">
                            {/* Left column - Filter Category Tabs */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-stretch overflow-x-auto md:overflow-visible flex-wrap md:flex-nowrap">
                                {/* Keyword Search Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between flex-shrink-0 ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white shadow-md' : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium whitespace-nowrap">Keyword Search</span>
                                        {getKeywordFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1.5 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center font-semibold ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getKeywordFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    <div className=" ml-1 flex-shrink-0">
                                        {activeFilterSection === 'keyword' ? <IoMdArrowDropdown size={16} /> : <IoMdArrowDropright size={16} />}
                                    </div>
                                </div>

                                {/* Company Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between flex-shrink-0 ${
                                        activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white shadow-md' : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium whitespace-nowrap">Company</span>
                                        {getCompanyFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1.5 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center font-semibold ${activeFilterSection === 'company' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getCompanyFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    <div className="ml-1 flex-shrink-0">
                                        {activeFilterSection === 'company' ? <IoMdArrowDropdown size={16} /> : <IoMdArrowDropright size={16} />}
                                    </div>
                                </div>

                                {/* Deal Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between flex-shrink-0 ${
                                        activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white shadow-md' : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium whitespace-nowrap">Deal</span>
                                        {getDealFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1.5 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center font-semibold ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getDealFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    <div className="ml-1 flex-shrink-0">
                                        {activeFilterSection === 'deal' ? <IoMdArrowDropdown size={16} /> : <IoMdArrowDropright size={16} />}
                                    </div>
                                </div>
                            </div>
                            
                            {/* Right column - Filter Content */}
                            <div className="col-span-full md:col-span-6 h-full overflow-visible mt-2 md:mt-0 pb-4 md:pb-0 relative">
                                {/* Keyword Search Content */}
                                <div className={`w-full md:w-1/2 ${activeFilterSection === 'keyword' ? '' : 'hidden'} relative flex flex-col overflow-visible`}>
                                    <div className="space-y-4">
                                        {/* Tag Filter */}
                                        <div className="flex items-center gap-4 border border-gray-300 rounded-md p-1 md:gap-2 relative">
                                            <div className="p-0 m-0 bg-white input-search relative flex items-center w-full">
                                                <Tags
                                                    TagsOptions={TagsOptions}
                                                    customPathname={generalPathname}
                                                    setTagsOptions={setTagsOptions} 
                                                    getSearchTags={getSearchTags}
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                />
                                                <Switch
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                    customPathname={generalPathname} 
                                                />
                                            </div>
                                            <div className="md:hidden flex items-center flex-shrink-0">
                                                <Tooltip title='Tag List'>
                                                    <FaInfoCircle 
                                                        size={16} 
                                                        color="grey" 
                                                        className="cursor-pointer px-[1px] focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-[#BC8B20] rounded"
                                                        onClick={fetchData}
                                                        role="button"
                                                        tabIndex={0}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                fetchData();
                                                            }
                                                        }}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div style={{ marginTop: "0.5rem" }} className="mt-2 cursor-pointer flex justify-end items-center text-xs gap-1">
                                            <input type="checkbox" checked={secondaryTagCheck} onChange={() => setSecondaryTagCheck(!secondaryTagCheck)} title="includes secondary tags" />
                                            <span>include secondary tags</span>
                                        </div>
                                        <Tooltip title='Tag List'>
                                            <FaInfoCircle
                                                size={16}
                                                color="grey"
                                                className="cursor-pointer hidden md:block absolute md:left-[103%] md:top-0 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-[#BC8B20] rounded"
                                                onClick={fetchData}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        fetchData();
                                                    }
                                                }}
                                            />
                                        </Tooltip>
                                    </div>

                                    {/* Investor, Company, Advisors */}
                                    <div className="mt-4 space-y-4">
                                        <Investor 
                                            options={InvestorOptions}
                                            setOptions={setInvestorOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(32)}
                                            label="Investor"
                                            open={select === 32}
                                        />
                                        <TargetCompany 
                                            options={TargetCompanyOptions}
                                            setOptions={setTargetCompanyOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(31)}
                                            label="Company"
                                            open={select === 31}
                                        />
                                        {customPathname === "/pe/advisors/pe-vc-advisors" || customPathname === "/vc/advisors/vc-advisors" ? (
                                            <LAdvisor 
                                                options={lAdvisorsOptions}
                                                setOptions={setlAdvisorsOptions}
                                                customPathname={generalPathname}
                                                label="Legal Advisors"
                                                accordionClick={() => accordionClick(18)}
                                                open={select === 18}
                                            />
                                        ) : (
                                            <TAdvisor 
                                                options={tAdvisorsOptions}
                                                setOptions={settAdvisorsOptions}
                                                label="Transaction Advisors"
                                                customPathname={generalPathname}
                                                accordionClick={() => accordionClick(19)}
                                                open={select === 19}
                                            />
                                        )}
                                    </div>
                                </div>

                                {/* Company Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-2 sm:gap-6 md:gap-x-6 md:gap-y-4 lg:gap-x-8 lg:gap-y-8 ${activeFilterSection === 'company' ? '' : 'hidden'}`}>
                                    <IndustryFilter
                                        IndustriesOptions={IndustriesOptions}
                                        setIndustriesOptions={setIndustriesOptions}
                                        customPathname={generalPathname}
                                        accordionClick={() => accordionClick(1)}
                                        open={select === 1}
                                        isPopupOpen={openFilterPopup === 'industry'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'industry' : null)}
                                    />
                                    <SectorFilter
                                        SectorOptions={SectorOptions}
                                        setSectorOptions={setSectorOptions}
                                        accordionClick={() => accordionClick(2)}
                                        customPathname={generalPathname}
                                        open={select === 2}
                                        isPopupOpen={openFilterPopup === 'sector'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)}
                                    />
                                    <InvestorCityTag
                                        CityOptions={CityOptions}
                                        setCityOptions={setCityOptions}
                                        customPathname={generalPathname}
                                        accordionClick={() => accordionClick(20)}
                                        open={select === 20}
                                        isPopupOpen={openFilterPopup === 'city'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)}
                                    />
                                </div>

                                {/* Deal Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-2 sm:gap-6 md:gap-x-6 md:gap-y-4 lg:gap-x-8 lg:gap-y-8 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                                    <StageFilter
                                        StageOptions={StageOptions}
                                        customPathname={customPathname}
                                        setStageOptions={setStageOptions}
                                        accordionClick={() => accordionClick(3)}
                                        open={select === 3}
                                        isPopupOpen={openFilterPopup === 'stage'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'stage' : null)}
                                    />
                                    <RoundFilter
                                        RoundOptions={RoundOptions}
                                        setRoundOptions={setRoundOptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(4)}
                                        open={select === 4}
                                        isPopupOpen={openFilterPopup === 'round'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'round' : null)}
                                    />
                                    <InvestorTypeFilter
                                        InvestorTypeOptions={InvestorTypeOptions}
                                        setInvestorTypeOptions={setInvestorTypeOptions}
                                        customPathname={generalPathname}
                                        isPopupOpen={openFilterPopup === 'investorType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorType' : null)}
                                    />
                                    <FirmTypeFilter
                                        FirmTypeOptions={FirmTypeOptions}
                                        setFirmTypeOptions={setFirmTypeOptions}
                                        customPathname={generalPathname}
                                        FirmSubTypeOptions={FirmSubTypeOptions}  
                                        setFirmSubTypeOptions={setFirmSubTypeOptions}
                                        dataPath="investments"
                                        isPopupOpen={openFilterPopup === 'firmType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'firmType' : null)}
                                    />
                                    <DealRangeFilter
                                        DealRange={DealRange}
                                        setDealRange={setDealRange}
                                        customPathname={generalPathname}
                                        isPopupOpen={openFilterPopup === 'dealRange'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealRange' : null)}
                                    />
                                    <InvestorDealFilter
                                        customPathname={generalPathname}
                                        invDealRange={invDealRange}
                                        setInvDealRange={setInvDealRange}
                                        isPopupOpen={openFilterPopup === 'invDealRange'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'invDealRange' : null)}
                                    />
                                </div>

                                {/* Empty State */}
                                {!activeFilterSection && (
                                    <div className="flex items-center justify-center h-40 text-gray-500">
                                        <p className="text-center text-sm md:text-base">Select a filter category from the left to view available filters</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                </form>
            </div>
            {showDefinitionModal && <DefinitionModal 
                    values={defValues} 
                    onClose={defCloseHandler} 
                    TagsOptions={TagsOptions} 
                    setTagsOptions={setTagsOptions}
                    customPathname={generalPathname}
                />}
        </div>
    );
}

